import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b728793"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OCriarRelatorioAtividades__Titulo",
  "data-testid": "OCriarRelatorioAtividades__Titulo"
}
const _hoisted_2 = { class: "OCriarRelatorioAtividades__Form" }
const _hoisted_3 = { class: "OCriarRelatorioAtividades__Periodo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-clock" }, null, -1))
const _hoisted_5 = { class: "OCriarRelatorioAtividades__Filtros" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-filter" }, null, -1))
const _hoisted_7 = { class: "OCriarRelatorioAtividades__Opcoes" }
const _hoisted_8 = { class: "OCriarRelatorioAtividades__Acoes" }
const _hoisted_9 = {
  key: 0,
  class: "OCriarRelatorioAtividades__Gerando",
  "data-testid": "OCriarRelatorioAtividades__Gerando"
}

import { computed, ref, ComputedRef, onMounted, reactive } from "vue"

  import Dialog from "primevue/dialog"
  import PButton from "primevue/button"
  import MMultiSelect from "@/components/Gerais/MMultiSelect/MMultiSelect.vue"
  import { MCalendario, MBotaoSelecionar, MCheckbox } from "@/components/Gerais"

  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarBaixadorDeArquivos } from "@/composable/UsarBaixadorDeArquivos/usarBaixadorDeArquivos"

  import {
    ListarProjetos,
    ParamsProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
  import {
    ListarProfissionais,
    ParamsProfissional,
  } from "@/repositorios/profissional/profissional.modelo"
  import {
    GerarArquivoDePagamento,
    GerarRelatorioAtividadesParams,
    RespostaAoBaixarRelatorio,
  } from "@/repositorios/relatorios/relatorios.modelo"
  import { RelatoriosRepositorio } from "@/repositorios/relatorios/relatorios.repositorio"

  import { helpers, required, requiredIf } from "@vuelidate/validators"
  import useVuelidate from "@vuelidate/core"
  import { EntidadeGenerica } from "@/types/gerais"
  import { Opcao } from "@/components/Gerais/index.d"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { estados } from "@/types/api"
  import { useI18n } from "vue-i18n"

  interface Props {
    teleportarPara?: string
    visible: boolean
  }
  interface EmitirVisibilidade {
    (event: "update:visible", visible: boolean): void
  }

  interface OpcapDeRelatorio extends Opcao {
    obrigatoriedadeProjetos: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCriarRelatorioAtividades',
  props: {
    teleportarPara: null,
    visible: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visible", visible: boolean): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    teleportarPara?: string
    visible: boolean
  }

  
  

  const { t } = useI18n()

  const opcoesDeRelatorios: OpcapDeRelatorio[] = [
    {
      icone: "pi pi-file-excel",
      rotulo: `${t('planilha')} (.xls)`,
      codigo: "0",
      obrigatoriedadeProjetos: false,
    },
    {
      icone: "pi pi-file",
      rotulo: `${t('arquivoDePagamento')} (.txt)`,
      codigo: "1",
      obrigatoriedadeProjetos: true,
    },
  ]
  const opcaoDeRelatorioSelecionado = ref<OpcapDeRelatorio>(
    opcoesDeRelatorios[0]
  )

  const { pegarDataDeHoje, pegarSomenteData, hoje, obterTimeZoneLocal } =
    usarDataHora()
  const { leitor, resolverLeitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { colher } = usarManipuladorObjetos()
  const { onErro } = usarMensagemUsuario()
  const { executarDownloadDeArquivo } = usarBaixadorDeArquivos()

  const projetoRep = new ProjetoRepositorio({ utilizaCache: true })
  const relatorioRep = new RelatoriosRepositorio({ utilizaCache: true })
  const profissionalRep = new ProfissionalRepositorio({ utilizaCache: true })

  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetoRep.listarProjetosFrontend,
    {
      "ordenar-por": ["asc.nome_projeto"],
      "por-pagina": 1000,
    }
  )

  const lerProfissionais = leitor<ListarProfissionais, ParamsProfissional>(
    profissionalRep.listarProfissionaisFrontend,
    {
      "ordenar-por": ["asc.nome"],
      "por-pagina": 1000,
    }
  )

  const dataInicio = ref<Date>(pegarDataDeHoje())
  const dataFim = ref<Date>(pegarDataDeHoje())
  const projetosSelecionados = ref<string[]>([])
  const projetos = ref<EntidadeGenerica[]>([])
  const profissionaisSelecionados = ref<string[]>([])
  const profissionais = ref<EntidadeGenerica[]>([])
  const tiposDeAtividadeSelecionados = ref<string[]>([])
  const incluirProfissionaisSemRegistro = ref<boolean>(false)
  const estadoDeCarregamentoProjetos = ref<number>(estados.INICIAL)
  const estadoDeCarregamentoProfissionais = ref<number>(estados.INICIAL)

  const parametrosInicialParaGerarRelatorio =
    reactive<GerarRelatorioAtividadesParams>({
      data_inicio: "",
      data_fim: "",
      ids_projetos_filtrados: [],
      ids_profissionais_filtrados: [],
      ids_atividades_filtradas: [],
      timezone: 0,
      incluirZerados: false,
    })

  const gerarRelatorio = escritor<
    { resultados: string[] },
    GerarRelatorioAtividadesParams
  >(relatorioRep.gerarRelatorioDeAtividades, [
    parametrosInicialParaGerarRelatorio,
    undefined,
  ])

  const baixarRelatorio = escritor<RespostaAoBaixarRelatorio, string>(relatorioRep.baixarRelatorio, [
    "",
    "",
  ])
  const baixarArquivoDePagamento = escritor<string, GerarArquivoDePagamento>(
    relatorioRep.baixarArquivoDePagamento,
    []
  )

  const regras = {
    dataInicio: {
      required: helpers.withMessage(t('campoObrigatorio'), required),
    },
    dataFim: { required: helpers.withMessage(t('campoObrigatorio'), required) },
    projetosSelecionados: {
      requiredIf: helpers.withMessage(
        t('campoObrigatorio'),
        requiredIf(
          () => opcaoDeRelatorioSelecionado.value.obrigatoriedadeProjetos
        )
      ),
    },
  }

  const $v = useVuelidate(regras, {
    dataInicio,
    dataFim,
    projetosSelecionados,
  })

  const maxDataInicio = computed(() => {
    const dataFinal = $v.value.dataFim.$model
    return $v.value.dataFim.$model ? dataFinal : hoje
  }) as ComputedRef<Date>

  const minDataFim = computed(() => {
    const dataInicial = $v.value.dataInicio.$model
    return $v.value.dataInicio.$model ? dataInicial : undefined
  }) as ComputedRef<Date | undefined>

  const maxDataFim = computed(() => hoje)

  const projetosEstaCarregando = computed(() => {
    return estadoDeCarregamentoProjetos.value === estados.PEDENTE
  })

  const profissionaisEstaCarregando = computed(() => {
    return estadoDeCarregamentoProfissionais.value === estados.PEDENTE
  })

  const emissorVisibilidade = computed({
    get() {
      return props.visible
    },
    set(visible: boolean) {
      emitir("update:visible", visible)
    },
  })
  const executarDownload = computed(() =>
    opcaoDeRelatorioSelecionado.value.codigo === "0"
      ? executarDowndloadDoRelatorio
      : executarDownloadArquivoDePagamento
  )
  const gerandoRelatorio = computed(
    () => gerarRelatorio.resultado.status === "pendente"
  )
  const baixandoRelatorio = computed(
    () => baixarRelatorio.resultado.status === "pendente"
  )
  const baixandoArquivoPagamento = computed(
    () => baixarArquivoDePagamento.resultado.status === "pendente"
  )

  const carregarProjetos = async () => {
    estadoDeCarregamentoProjetos.value = estados.PEDENTE
    await lerProjetos.executar()

    resolverLeitor<ListarProjetos>(lerProjetos.resultado, {
      sucesso: (dados) => {
        projetos.value = colher<ListarProjetos, { id: string; nome: string }>(
          dados,
          ["id", "nomeProjeto"],
          ["id", "nome"]
        )
        estadoDeCarregamentoProjetos.value = estados.SUCESSO
      },
      erro: (erro) => {
        onErro({
          resumo: t('erroAoCarregarProjetos'),
          detalhes: t('ocorreuUmErroAoBuscarProjetos'),
        })
        estadoDeCarregamentoProjetos.value = estados.ERRO
      },
    })
  }

  const carregarProfissionais = async () => {
    estadoDeCarregamentoProfissionais.value = estados.PEDENTE

    await lerProfissionais.executar()

    resolverLeitor<ListarProfissionais>(lerProfissionais.resultado, {
      sucesso: (dados) => {
        estadoDeCarregamentoProfissionais.value = estados.SUCESSO
        profissionais.value = colher<
          ListarProfissionais,
          { id: string; nome: string }
        >(dados, ["id", "nome"])
      },
      erro: (erro) => {
        onErro({
          resumo: t("erroAoCarregarProfissionais"),
          detalhes: t("ocorreuUmErroAoBuscarProfissionais"),
        })
        estadoDeCarregamentoProfissionais.value = estados.ERRO
      },
    })
  }
  const validarForm = (camposValidados: boolean) => {
    $v.value.$touch()

    if (!camposValidados) {
      onErro({
        resumo: t("camposInvalidos"),
        detalhes: t("preenchaOsCamposCorretamente"),
      })
      return false
    }
    return true
  }
  const executarDowndloadDoRelatorio = async () => {
    if (!validarForm(await $v.value.$validate())) {
      return
    }
    const parametrosGerarRelatorio: GerarRelatorioAtividadesParams = {
      data_inicio: dataInicio.value.toISOString(),
      data_fim: dataFim.value.toISOString(),
      ids_projetos_filtrados: projetosSelecionados.value,
      ids_profissionais_filtrados: profissionaisSelecionados.value,
      ids_atividades_filtradas: tiposDeAtividadeSelecionados.value,
      timezone: obterTimeZoneLocal(),
      incluirZerados: incluirProfissionaisSemRegistro.value,
    }

    gerarRelatorio.mudarArgumentos([parametrosGerarRelatorio, undefined])
    await gerarRelatorio.executar()

    resolver<{ resultados: string[] }>(gerarRelatorio.resultado, {
      sucesso: async (dados) => {
        const urlParaDownload = dados.resultados[0]
        baixarRelatorio.mudarArgumentos([urlParaDownload, ""])
        await baixarRelatorio.executar()

        resolver(baixarRelatorio.resultado, {
          sucesso: ({ blob, nomeArquivo }) => {

            const nomeArquivoSemExtensao = nomeArquivo.split(".")[0]
            const arquivoXLS = blob
            executarDownloadDeArquivo({
              conteudo: arquivoXLS,
              nome: nomeArquivoSemExtensao,
              extensao: ".xlsx"
            })
          },
        })
      },
    })
  }
  const executarDownloadArquivoDePagamento = async () => {
    if (!validarForm(await $v.value.$validate())) {
      return
    }

    const dadosGerarArquivoDePagamento: GerarArquivoDePagamento = {
      ids_projetos_filtrados: projetosSelecionados.value,
      data_fim: pegarSomenteData(dataFim.value),
      data_inicio: pegarSomenteData(dataInicio.value),
    }
    baixarArquivoDePagamento.mudarArgumentos([dadosGerarArquivoDePagamento])
    await baixarArquivoDePagamento.executar()

    resolver(baixarArquivoDePagamento.resultado, {
      sucesso: (dados) => {
        const nomeDoArquivo = `${t("arquivoDePagamentoInicio")}${pegarSomenteData(
          dataInicio.value
        )}${t("arquivoDePagamentoFim")}${pegarSomenteData(dataFim.value)}`
        executarDownloadDeArquivo({
          conteudo: dados,
          nome: nomeDoArquivo,
          extensao: ".txt",
          tipo: "text/plain",
        })
      },
      erro: (erro) => {
        onErro({
          resumo: t('erroAoGerarArquivoDePagamento'),
          detalhes: erro.mensagem,
        })
      },
    })
  }
  const fecharGeradorDeRelatorio = () => {
    emissorVisibilidade.value = false
  }
  onMounted(() => {
    carregarProjetos()
    carregarProfissionais()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(emissorVisibilidade),
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_isRef(emissorVisibilidade) ? (emissorVisibilidade).value = $event : null)),
    "append-to": __props.teleportarPara,
    class: "OCriarRelatorioAtividades",
    "data-testid": "OCriarRelatorioAtividades",
    "dismissable-mask": "",
    draggable: false,
    header: "Header",
    modal: true,
    style: { width: '600px' }
  }, {
    header: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('configurarRelatorioDeAtividades')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_2, [
        _createVNode(_unref(MBotaoSelecionar), {
          modelValue: opcaoDeRelatorioSelecionado.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((opcaoDeRelatorioSelecionado).value = $event)),
          class: "OCriarRelatorioAtividades__SelecionarTipo",
          opcoes: opcoesDeRelatorios
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(MCalendario), {
            modelValue: _unref($v).dataInicio.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($v).dataInicio.$model) = $event)),
            id: "data-inicio",
            class: "OCriarRelatorioAtividades__DataInicio",
            "data-testid": "OCriarRelatorioAtividades__DataInicio",
            destino: __props.teleportarPara,
            "max-data": _unref(maxDataInicio),
            "mensagem-de-erro": _unref($v).dataInicio.$errors[0]?.$message,
            obrigatorio: "",
            rotulo: _unref(t)('dataDeInicio')
          }, null, 8, ["modelValue", "destino", "max-data", "mensagem-de-erro", "rotulo"]),
          _createVNode(_unref(MCalendario), {
            modelValue: _unref($v).dataFim.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref($v).dataFim.$model) = $event)),
            id: "data-fim",
            class: "OCriarRelatorioAtividades__DataFim",
            "data-testid": "OCriarRelatorioAtividades__DataFim",
            destino: __props.teleportarPara,
            "max-data": _unref(maxDataFim),
            "mensagem-de-erro": _unref($v).dataFim.$errors[0]?.$message,
            "min-data": _unref(minDataFim),
            obrigatorio: "",
            rotulo: _unref(t)('dataDeFim')
          }, null, 8, ["modelValue", "destino", "max-data", "mensagem-de-erro", "min-data", "rotulo"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(MMultiSelect, {
              modelValue: _unref($v).projetosSelecionados.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref($v).projetosSelecionados.$model) = $event)),
              carregando: _unref(projetosEstaCarregando),
              class: "OCriarRelatorioAtividades__Projeto",
              "data-testid": "OCriarRelatorioAtividades__Projeto",
              destino: __props.teleportarPara,
              "mensagem-de-erro": _unref($v).projetosSelecionados.$errors[0]?.$message,
              nome: "projetos",
              obrigatorio: "",
              "option-label": "nome",
              "option-value": "id",
              options: projetos.value,
              placeholder: _unref(t)('projetos'),
              width: "530px"
            }, null, 8, ["modelValue", "carregando", "destino", "mensagem-de-erro", "options", "placeholder"]),
            (opcaoDeRelatorioSelecionado.value.codigo === '0')
              ? (_openBlock(), _createBlock(MMultiSelect, {
                  key: 0,
                  modelValue: profissionaisSelecionados.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((profissionaisSelecionados).value = $event)),
                  carregando: _unref(profissionaisEstaCarregando),
                  class: "OCriarRelatorioAtividades__Profissional",
                  "data-testid": "OCriarRelatorioAtividades__Profissional",
                  destino: __props.teleportarPara,
                  nome: "profissional",
                  "option-label": "nome",
                  "option-value": "id",
                  options: profissionais.value,
                  placeholder: _unref(t)('profissionais'),
                  width: "530px"
                }, null, 8, ["modelValue", "carregando", "destino", "options", "placeholder"]))
              : _createCommentVNode("", true),
            (opcaoDeRelatorioSelecionado.value.codigo === '0')
              ? (_openBlock(), _createBlock(_unref(MCheckbox), {
                  key: 1,
                  modelValue: incluirProfissionaisSemRegistro.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((incluirProfissionaisSemRegistro).value = $event)),
                  binary: true,
                  class: "OCriarRelatorioAtividades__IncluirProfissionaisSemRegistro",
                  "data-testid": "OCriarRelatorioAtividades__IncluirProfissionaisSemRegistro",
                  label: _unref(t)('incluirInformacoesDeProfissionais'),
                  nome: "incluir-profissionais-sem-registro"
                }, null, 8, ["modelValue", "label"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (
            _unref(baixandoRelatorio) || _unref(gerandoRelatorio) || _unref(baixandoArquivoPagamento)
          )
            ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_unref(t)('porFavorAguarde')), 1))
            : (_openBlock(), _createBlock(_unref(PButton), {
                key: 1,
                onClick: fecharGeradorDeRelatorio,
                class: "OCriarRelatorioAtividades__Cancelar p-button-danger p-button-text",
                "data-testid": "OCriarRelatorioAtividades__Cancelar",
                label: _unref(t)('cancelar')
              }, null, 8, ["label"])),
          _createVNode(_unref(PButton), {
            onClick: _unref(executarDownload),
            class: "OCriarRelatorioAtividades__Confirmar p-button-success",
            "data-testid": "OCriarRelatorioAtividades__Confirmar",
            disabled: 
            _unref(baixandoRelatorio) || _unref(gerandoRelatorio) || _unref(baixandoArquivoPagamento)
          ,
            "icon-pos": "right",
            label: _unref(t)('confirmar'),
            loading: 
            _unref(baixandoRelatorio) || _unref(gerandoRelatorio) || _unref(baixandoArquivoPagamento)
          
          }, null, 8, ["onClick", "disabled", "label", "loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "append-to"]))
}
}

})